import * as React from "react";

export const IconImport = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_icon_import)">
      <path
        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333L2.5 7.5C2.5 7.04167 2.66319 6.64931 2.98958 6.32292C3.31597 5.99653 3.70833 5.83333 4.16667 5.83333L7.5 5.83333V7.5L4.16667 7.5L4.16667 15.8333L15.8333 15.8333V7.5H12.5V5.83333H15.8333C16.2917 5.83333 16.684 5.99653 17.0104 6.32292C17.3368 6.64931 17.5 7.04167 17.5 7.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5L4.16667 17.5ZM10 13.3333L6.66667 10L7.83333 8.83333L9.16667 10.1458L9.16667 0L10.8333 0L10.8333 10.1458L12.1667 8.83333L13.3333 10L10 13.3333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_icon_import">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
